import React, { useState, useEffect } from 'react';
// import styles from './AdvancedInstitutionalRCRA.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

const firstOptions = {
  "Controls are in place": {
    param: "RCRA_IC_CODE='Y'",
    isIncluded: false,
    objectIds: null
  },
  "No controls in place or no control information reported": {
    param: "RCRA_IC_CODE='U'",
    isIncluded: false,
    objectIds: null
  }
};
const secondOptions = {
  "Proprietary": {
    param: "RCRA_IC_PR_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Governmental": {
    param: "RCRA_IC_GC_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Informational Devices" : {
    param: "RCRA_IC_ID_IND='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Enforcement/Permit Tools" : {
    param:"RCRA_IC_EP_IND='Y'" ,
    isIncluded: false,
    objectIds: null
  },
  "No types reported" : {
    param: "(RCRA_IC_CODE='U' and RCRA_IC_PR_IND='U' AND RCRA_IC_GC_IND='U' AND RCRA_IC_ID_IND='U' AND RCRA_IC_EP_IND='U')",
    isIncluded: false,
    objectIds: null
  }
};

const AdvancedInstitutionalRCRA = (props) => {
  const [firstBoxSectionDivs, setFirstBoxSectionDivs] = useState<Array<any>>([]);
  const [secondBoxSectionDivs, setSecondBoxSectionDivs] = useState<Array<any>>([]);

  const toggleParam = async ([firstOrSecond, key]) => {
    if (firstOrSecond === 'first') {
      firstOptions[key].isIncluded = !firstOptions[key].isIncluded;
    } else if (firstOrSecond === 'second') {
      secondOptions[key].isIncluded = !secondOptions[key].isIncluded;
    }
    passUpdatedParams();
  }

  const passUpdatedParams = () => { 
    let paramArray: Array<string> = [];
    for (let option in firstOptions) {
      if (firstOptions[option].isIncluded === true) {
        paramArray.push(firstOptions[option].param)
      }
    }
    for (let option in secondOptions) {
      if (secondOptions[option].isIncluded === true) {
        paramArray.push(secondOptions[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateRCRAParams(paramArray);
  }


  const buildCheckboxDivs = (clear?) => {
    let firstBoxes: Array<any> = [];
    let secondBoxes: Array<any> = [];

    if (clear) {
      for (let key in firstOptions) {
        firstOptions[key]["isIncluded"] = false;
        firstBoxes.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
      // do the same for the second set of options
      for (let key in secondOptions) {
        secondOptions[key]["isIncluded"] = false;
        secondBoxes.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {

      for (let key in firstOptions) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (firstOptions[key]["isIncluded"] === true) {
          firstBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          firstBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
      // do the same for the second set of options
      for (let key in secondOptions) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (secondOptions[key]["isIncluded"] === true) {
          secondBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          secondBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }

    passUpdatedParams();
    setFirstBoxSectionDivs(firstBoxes);
    setSecondBoxSectionDivs(secondBoxes);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Control Deployment is: </label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {firstBoxSectionDivs}
      </div>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Controls are: </label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {secondBoxSectionDivs}
      </div>
    </div>
  );
}

export default AdvancedInstitutionalRCRA;
